import { Delete, Plus, Trash2 } from "lucide-react";
import ReusebleTable from "../../../../../components/ReusebleTable";
import { CreditAlertsColumns } from "../model/creditAlertsTypes";
import { useCreditAlertsViewModel } from "../viewmodel/creditAlertsViewModel";

import { CreateCreditAlert } from "./createCreditAlert";
import { format } from "date-fns";
import Toast from "../../../../../components/Toast";
import { setCurrentPage, setToast } from "../viewmodel/creditAlerts.actions";
import { ConfirmDeleteModal } from "../../../../../components/ConfirmationPopUp";
import Pagination from "../../../JobManagement/Components/Pagination";

const parseUtcDate = (dateString: string) => {
  const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(dateString);
  return new Date(hasTimezone ? dateString : `${dateString}Z`);
};

export const CreditAlertsView = () => {
  const {
    state,
    dispatch,
    getCreditAlertData,
    getCreditHistoryData,
    deleteCreditAlert,
  } = useCreditAlertsViewModel();
  return (
    <div>
      <div className="flex justify-end items-center mt-4 mb-4">
        <button
          onClick={() => {
            //   setEditingFlow(undefined);
            //   dispatch({ type: "SET_DIALOG_MODE", payload: "create" });
            dispatch({ type: "SET_CREDIT_ALERT_DIALOG_OPEN", payload: true });
          }}
          className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition-colors flex items-center"
        >
          <Plus className="h-4 w-4 mr-2" />
          Create Credit Alert
        </button>
      </div>
      {state.loading ? (
        <div className="text-center py-10 text-gray-500">Loading...</div>
      ) : state.creditAlerts?.length === 0 ? (
        <div className="text-center py-10 text-gray-500 border rounded-lg">
          No Data Found
        </div>
      ) : (
        <ReusebleTable
          currentPage={state.currentPage}
          pageSize={state.limit}
          total={state.total}
          onPageChange={(page) => {
            // dispatch({ type: "SET_PAGE", payload: page });
            // getCreditHistoryData();
          }}
          headers={CreditAlertsColumns.map((col) => col.title)}
          data={state.creditAlerts}
          renderRow={(row) => (
            <>
              <td className="p-4 text-sm text-gray-500 whitespace-nowrap">
                {row.alert_type || "-"}
              </td>
              <td className="p-4 text-sm text-gray-500 whitespace-nowrap">
                {row.threshold_value || "-"}
              </td>
              <td className="p-4 text-sm text-gray-500 whitespace-nowrap">
                {row.trigger_count || "-"}
              </td>
              <td className="text-sm text-gray-500 whitespace-nowrap p-6">
                {format(parseUtcDate(row.created_at), "MMM d, yyyy")}
                <span className="ml-1 text-xs text-gray-400">
                  {format(parseUtcDate(row.created_at), "hh:mm a")}
                </span>
              </td>
              <td className="p-4 text-sm text-gray-500 whitespace-nowrap">
                <Trash2
                  className="h-4 w-4 text-red-600 cursor-pointer"
                  onClick={() => {
                    dispatch({
                      type: "SET_DELETING_ALERT_ID",
                      payload: row.id,
                    });
                    dispatch({
                      type: "SET_DELETE_ALERT_DIALOG_OPEN",
                      payload: true,
                    });
                  }}
                />
              </td>
            </>
          )}
        />
      )}
      {state.total > state.limit && (
        <div className="mt-6 flex justify-center items-center px-4 overflow-x-auto">
          <Pagination
            postsPerPage={state.limit}
            totalPosts={state.total}
            currentPage={state.currentPage}
            setCurrentPage={(page) => {
              const pageNumber =
                typeof page === "function" ? page(state.currentPage) : page;
              dispatch(setCurrentPage(pageNumber));
              
            }}
          />
        </div>
      )}
      <CreateCreditAlert
        state={state}
        getCreditHistoryData={getCreditHistoryData}
        dispatch={dispatch}
        open={state.isCreditAlertDialogOpen}
        onClose={() =>
          dispatch({ type: "SET_CREDIT_ALERT_DIALOG_OPEN", payload: false })
        }
      />

      <Toast
        message={state.toast.message}
        type={state.toast.type}
        isVisible={state.toast.isVisible}
        duration={500}
        onClose={() =>
          dispatch(setToast({ isVisible: false, message: "", type: "success" }))
        }
      />
      <ConfirmDeleteModal
        open={state.deleteDialogOpen}
        title="Delete Credit Alert?"
        entityName={
          state.creditAlerts.find(
            (alert) => alert.id === state.deletingAalertId,
          )?.alert_type
        }
        loading={state.loading}
        onCancel={() =>
          dispatch({ type: "SET_DELETE_ALERT_DIALOG_OPEN", payload: false })
        }
        onConfirm={() => {
          if (state.deletingAalertId) {
            deleteCreditAlert(state.deletingAalertId);
          } // dispatch({ type: "DELETE_CREDIT_ALERT", payload: state.deletingAalertId });
        }}
      />
    </div>
  );
};
